import { useRef } from 'react';

import {
  computeNextTableReloadSkeletonState,
  initialTableReloadSkeletonState,
} from './tableReloadSkeletonUseCase';

/**
 * Holds table skeleton visible from filter/pagination reload mutation until table refetch completes.
 * @param {boolean} isReloadMutationPending - Combined pending flag for reload mutations only
 * @param {boolean} isTableFetching - Active table query fetch (any cause)
 * @returns {boolean} Whether to keep skeleton for filter reload
 */
export function useTableReloadSkeletonHold(isReloadMutationPending, isTableFetching) {
  const stateRef = useRef(initialTableReloadSkeletonState);

  stateRef.current = computeNextTableReloadSkeletonState(stateRef.current, {
    isReloadMutationPending,
    isTableFetching,
  });

  return stateRef.current.hold;
}
